import axios from 'axios'
import { clearSession, getToken } from './authStorage'

function resolveApiBaseUrl() {
  const base = String(import.meta.env.VITE_API_BASE_URL || '').trim()
  if (base) return `${base.replace(/\/$/, '')}/api`
  return import.meta.env.VITE_API_URL || '/api'
}

const api = axios.create({
  baseURL: resolveApiBaseUrl(),
  timeout: 15000,
})

api.interceptors.request.use((config) => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status
    const url = String(error.config?.url || '')
    const isLoginRequest = url.includes('/auth/login')

    if (status === 401 && !isLoginRequest) {
      clearSession()
      const onLoginPage = window.location.pathname.startsWith('/login')
      const isMeRequest = url.includes('/auth/me')
      if (!isMeRequest && !onLoginPage) {
        window.location.assign('/login')
      }
    }

    return Promise.reject(error)
  },
)

export function getApiBaseUrl() {
  return resolveApiBaseUrl()
}

export function toUserError(error) {
  const status = error.response?.status
  const serverMessage = error.response?.data?.message
  const url = String(error.config?.url || '')
  if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
    return new Error('서버에 연결할 수 없습니다.')
  }
  if (status === 401) {
    return new Error(serverMessage || '아이디 또는 비밀번호를 확인해주세요.')
  }
  if (status === 403) {
    return new Error(serverMessage || '권한이 없습니다.')
  }
  if (status === 413) {
    return new Error('파일 크기가 허용 범위를 초과했습니다.')
  }
  if (status === 400) {
    return new Error(serverMessage || '요청을 처리하지 못했습니다.')
  }
  if (status === 503) {
    return new Error('서버 처리 시간이 초과되었습니다. 잠시 후 다시 시도해주세요.')
  }
  if (status === 500 && url.includes('/purchase-request-import/')) {
    return new Error('견적서 분석 중 서버 오류가 발생했습니다.')
  }
  if (status >= 500) {
    return new Error('데이터를 불러오는 중 오류가 발생했습니다.')
  }
  return new Error(serverMessage || '요청을 처리하지 못했습니다.')
}

export default api
